import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import globalProgramStore from '../../../../stores/program-store';
import globalCourseStore from '../../../../stores/global-course-store';
import { exportStudentAttendanceToExcelOperation } from '../operations/export-student-attendance-to-excel-operation';

interface ExportStudentAttendanceDialogProps {
  visible: boolean;
  onHide: () => void;
}

export const ExportStudentAttendanceDialog: React.FC<
  ExportStudentAttendanceDialogProps
> = ({ visible, onHide }) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [loading, setLoading] = useState(false);

  const handleHide = () => {
    if (loading) {
      return;
    }
    onHide();
  };

  const handleExport = async () => {
    const programId = globalProgramStore.getCurrentId();
    const courseId = globalCourseStore.getCurrentCourse()?.metadata.id;

    await exportStudentAttendanceToExcelOperation(
      programId,
      courseId,
      startDate,
      endDate,
      setLoading,
      handleHide,
    );
  };

  return (
    <Dialog
      header="ייצוא נוכחות לסטודנטים"
      visible={visible}
      style={{ width: '520px', maxWidth: '95vw' }}
      onHide={handleHide}
      dismissableMask={!loading}
      closable={!loading}
      draggable={false}
      resizable={false}
    >
      <div
        style={{
          direction: 'rtl',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <label style={{ fontSize: '14px', color: '#4b5563' }}>מתאריך</label>
            <Calendar
              value={startDate}
              onChange={(e) => setStartDate((e.value as Date) ?? null)}
              dateFormat="dd/mm/yy"
              showIcon
              showButtonBar
              inputStyle={{ textAlign: 'right' }}
              style={{ width: '100%', direction: 'ltr' }}
              disabled={loading}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <label style={{ fontSize: '14px', color: '#4b5563' }}>
              עד תאריך
            </label>
            <Calendar
              value={endDate}
              onChange={(e) => setEndDate((e.value as Date) ?? null)}
              dateFormat="dd/mm/yy"
              showIcon
              showButtonBar
              inputStyle={{ textAlign: 'right' }}
              style={{ width: '100%', direction: 'ltr' }}
              disabled={loading}
            />
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'left',
            gap: '10px',
            marginTop: '8px',
          }}
        >
          <Button
            label="ביטול"
            severity="secondary"
            outlined
            style={{ height: '35px' }}
            onClick={handleHide}
            disabled={loading}
          />
          <Button
            label="ייצוא לאקסל"
            icon="pi pi-file-excel"
            style={{ height: '35px' }}
            onClick={handleExport}
            loading={loading}
            disabled={loading}
          />
        </div>
      </div>
    </Dialog>
  );
};
